import { version } from '@algolia/autocomplete-shared';

export const userAgents = [{ segment: 'autocomplete-js', version }];
